interface NativePickupPoint {
  provider: 'inpost-geowidget'; carrier: 'inpost'; code: string; name: string;
  address: string; country: string; packageIndex: number; shippingMethod: string;
}
export function getNativePickupPoints(rawData: Record<string, unknown>): NativePickupPoint[] {
  if (!Array.isArray(rawData.meta_data)) return [];
  const value: unknown = rawData.meta_data.find(item => item?.key === '_ecomflow_pickup_points')?.value;
  if (!Array.isArray(value)) return [];
  return value.filter((point): point is NativePickupPoint => point && point.provider === 'inpost-geowidget'
    && point.carrier === 'inpost' && ['code', 'name', 'address', 'country', 'shippingMethod'].every(key => typeof point[key] === 'string')
    && /^[A-Z0-9-]{2,30}$/.test(point.code) && Number.isInteger(point.packageIndex) && point.packageIndex >= 0);
}
